import './footer.css'
import tower from '../../../static/tower.png';
import email from '../../../static/email.png';

const Footer = () => {
    return (
        <footer>
            <div id="link-container">
            </div>

            <div id='social-link-container'>
                <a href='https://mp.weixin.qq.com/s/-kH3vHTjbO-BJY_jhKWFyQ' className='icon fa fa-weixin'></a>
                <a href='https://instagram.com/huapsychology?igshid=8yp3i2plxubl' className='icon fab fa-instagram'></a>
                <a href='https://www.facebook.com/HuaPsychology-106684791159664' className='icon fab fa-facebook'></a>
                <a href='https://weibo.com/u/7458291593' className='icon fab fa-weibo'></a>
                <a href = "https://mail.google.com/mail/?view=cm&fs=1&to=huapsych@uw.edu" className="icon far fa-envelope"></a>
            </div>

            <div id="image-container">
            </div>
        </footer>
    )
}

export default Footer